const profile = {
  profile: {
    title: "档案",
    personalInfo: "个人信息",
    name: "姓名",
    email: "电子邮件",
    updateProfile: "更新档案",
    createSelfTitle: "创建您的档案",
    createOtherTitle: "创建新档案",
    createSelfDesc: "请提供您的出生信息，以生成个人紫微斗数星图。",
    createOtherDesc: "请输入您要为其创建星图的人的详细信息。",
    createSelfSuccess: "您的档案已成功创建！",
    createOtherSuccess: "档案已成功创建！",
    createError: "创建档案时出错。请重试。"
  },
  settings: {
    title: "设置",
    theme: "主题",
    language: "语言",
    notifications: "通知",
    privacy: "隐私",
    account: "账户",
    deleteAccount: "删除账户",
    themes: {
      light: "浅色",
      dark: "深色",
      system: "系统默认",
    },
  },
};

export default profile; 